import { applySelectedNodeClass, clearSelectedNodeClasses } from '../../FlowchartView/hooks/utils/nodeSelectionDom';

const CARD = '.task-node, .decision-node, .milestone-node, .note-node';

/** Flip the highlight on the cards themselves, before React re-renders the board. */
export function paintBoardSelection(root, ids) {
  if (!root) return;
  clearSelectedNodeClasses(root);
  ids.forEach((id) => {
    const escaped = window.CSS?.escape ? window.CSS.escape(String(id)) : String(id);
    const host = root.querySelector(`[data-board-node="${escaped}"]`);
    applySelectedNodeClass(host?.querySelector(CARD));
  });
}
